import type { ReactNode, ButtonHTMLAttributes } from "react";
import styles from "~/styles/burn-rate.module.css";

interface CircularButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  size?: "sm" | "md" | "lg";
  variant?: "default" | "primary" | "danger";
}

export function CircularButton({
  children,
  size = "md",
  variant = "default",
  className = "",
  ...props
}: CircularButtonProps) {
  const sizeClass =
    size === "sm" ? styles.circSm : size === "lg" ? styles.circLg : styles.circMd;
  const variantClass =
    variant === "primary"
      ? styles.circPrimary
      : variant === "danger"
      ? styles.circDanger
      : styles.circDefault;

  return (
    <button
      className={`${styles.circularBtn} ${sizeClass} ${variantClass} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
